import { loadScript } from '@tencent/vft-utils';
import { getUrlParam } from '@tencent/vft-common/util';

export * from './url';

export function setTitle(title: string) {
  if (title === undefined || window.document.title === title) {
    return;
  }
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  // 替换成站标favicon路径或者任意存在的较小的图片即可
  iframe.setAttribute('src', '/favicon.ico');
  const iframeCallback = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}

let shield: { setStrategy: (arg0: any) => void; run: () => Promise<any> } | null = null;
// eslint-disable-next-line max-len
export async function shieldRun(
  secInfo: any,
  callback: () => any,
  errCallBack: (arg0: any) => any,
) {
  if (!(window as any).VftShield) {
    await loadScript(
      'https://vm.gtimg.cn/tencentvideo_v1/script/film/weixin/v3/lib/vftshield.min.js',
    );
  }
  // @ts-ignore
  shield = shield || new VftShield(); // eslint-disable-line
  // @ts-ignore
  shield.setStrategy(secInfo); // conifg具有类似该结构{iRet: xxx, sAppId: yyy}
  // @ts-ignore
  shield.run().then(
    () => {
      // 验证成功
      callback && callback(); // eslint-disable-line
    },
    (e: any) => {
      errCallBack && errCallBack(e); // eslint-disable-line
    },
  );
}

export function throttle(fn: { apply: (arg0: any, arg1: any[]) => void }, delay = 50) {
  let timer: number | null = null;
  return (...args: any) => {
    if (!timer) {
      timer = setTimeout(() => {
        // @ts-ignore
        fn.apply(this, args);
        timer = null;
      }, delay);
    }
  };
}
export function formatTimeStamp(time: string) {
  if (!time) {
    return Date.now();
  }
  return (
    Date.parse(String(new Date(time))) || Date.parse(String(new Date(time.replace(/-/g, '/'))))
  );
}

export function dateFormat(val: string, format: string) {
  const date = new Date(val);
  let fmt = format || 'yyyy-MM-dd';
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(date.getDate())) return '';
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        // @ts-ignore
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length),
      );
    }
  }
  return fmt;
}

export const numberToString = (number: number | string) => {
  if (String(number).match(/\D/) || String(number).length >= 14) return String(number);
  const zhArray = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']; // 数字对应中文
  const baseArray = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万']; // 进位填充字符，第一位是 个位，可省略
  let string = String(number)
    .split('')
    .reverse()
    .map((item, index) => {
      // 把数字切割成数组并倒序排列，然后进行遍历转成中文
      // 如果当前位为0，直接输出数字， 否则输出 数字 + 进位填充字符
      item = Number(item) === 0 ? zhArray[Number(item)] : zhArray[Number(item)] + baseArray[index];
      return item;
    })
    .reverse()
    .join(''); // 倒叙回来数组，拼接成字符串
  string = string.replace(/^一十/, '十'); // 如果以 一十 开头，可省略一
  string = string.replace(/零+/, '零'); // 如果有多位相邻的零，只写一个即可
  return string;
};

/* 腾讯充值插件 */
export function loadRechargePlugin() {
  const param = getUrlParam('floatIcon');
  if (param === 'bottom' || param === 'float') {
    loadScript('https://midas.gtimg.cn/floatIcon/index.js');
  }
}

/**
 * 截取字符串
 * @param {string} str
 * @param {number} len
 * @return {string}
 */
export function cutStrWithEmoji(str: string, len: number) {
  if (typeof str !== 'string') {
    return str;
  }
  let length = 0;
  const strArr = Array.from(str); // ES6的Array.from支持代理对的解析
  const strArrlen = strArr.length;
  let result = '';

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < strArrlen; i++) {
    const item = strArr[i];
    length += 1;
    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length += 1;
    }
    result = result.concat(item);
    if (length >= len) {
      if (i === strArrlen - 1) {
        return result;
      }
      result = result.concat('...');
      return result;
    }
  }
  return str;
}
